// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-catalog-__slug-indexstyleGrid-container-bsefv{margin:0 auto;max-width:1536px;padding:0 24px;width:100%}.pages-catalog-__slug-indexstyleGrid-grid-biotb{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.pages-catalog-__slug-indexstyleGrid-col6-blsjw{grid-column:span 6}.pages-catalog-__slug-indexstyleGrid-col3-bwsue{grid-column:span 3}.pages-catalog-__slug-indexstyleGrid-col4-kldri{grid-column:span 4}.pages-catalog-__slug-indexstyleGrid-col9-biftj{grid-column:span 9}.pages-catalog-__slug-indexstyleGrid-col12-xxrjf{grid-column:span 12}.pages-catalog-__slug-indexstyleGrid-alignItemsStart-bytkr{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "pages-catalog-__slug-indexstyleGrid-container-bsefv",
	"grid": "pages-catalog-__slug-indexstyleGrid-grid-biotb",
	"col6": "pages-catalog-__slug-indexstyleGrid-col6-blsjw",
	"col3": "pages-catalog-__slug-indexstyleGrid-col3-bwsue",
	"col4": "pages-catalog-__slug-indexstyleGrid-col4-kldri",
	"col9": "pages-catalog-__slug-indexstyleGrid-col9-biftj",
	"col12": "pages-catalog-__slug-indexstyleGrid-col12-xxrjf",
	"alignItemsStart": "pages-catalog-__slug-indexstyleGrid-alignItemsStart-bytkr"
};
module.exports = ___CSS_LOADER_EXPORT___;
